var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47979 6.67007V1.41406H23V6.67007H9.47979Z",
    fill: "#0E0D09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7439 23.0218V17.7658H22.9999V23.0218H17.7439Z",
    fill: "#0E0D09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7439 14.8547V9.59871H22.9999V14.8547H17.7439Z",
    fill: "#0E0D09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.8547V9.59871H6.25601V14.8547H1Z",
    fill: "#0E0D09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.0225V17.7665H14.5202V23.0225H1Z",
    fill: "#0E0D09"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.67036V1.41436H6.25601V6.67036H1Z",
    fill: "#0E0D09"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1065 12.226C15.1065 13.921 13.7324 15.295 12.0374 15.295C10.3424 15.295 8.96834 13.921 8.96834 12.226C8.96834 10.531 10.3424 9.15692 12.0374 9.15692C13.7324 9.15692 15.1065 10.531 15.1065 12.226Z",
    fill: "#F6A62D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentra);
export default __webpack_public_path__ + "static/media/Sentra.0e5264e484cad618e0b66c4b085d91ca.svg";
export { ForwardRef as ReactComponent };